import { IPortalConfig } from "@msx/platform-services";


export interface IAppConfig extends IPortalConfig {
  notificaitonConfig: {
    active: boolean,
    customPanel: boolean,
  },
  brandConfig: {
    active: boolean,
    loginScreenOnly: boolean,
  }
  appNameTooltip: string,
  isLocalAnnouncement: boolean,
}

export const appConfig: IAppConfig = {
  appName: 'Deal Assistance',
  appNameTooltip: 'Deal Assistance',
  authConfig: {
    clientId: process.env.REACT_APP_AD_CLIENT_ID,
    authority: process.env.REACT_APP_AD_AUTHORITY,
  },
  apiConfig: {
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    resource: process.env.REACT_APP_API_RESOURCE,
  },
  telemetryConfig: {
    instrumentationKey: process.env.REACT_APP_INSTRUMENTATION_KEY,
    logPayload: true,
  },
  UTPConfig: {
    EnvironmentName: 'Non-Production',
    ServiceOffering: 'Example Service Offering',
    ServiceLine: 'Example Service Line',
    Service: 'Example Service',
    ComponentName: 'MDA Portal',
    ComponentId: 'Example Id',
  },
  extensionConfig: {
    RING: 1,
  },
  isLocalAnnouncement: false,
  isMockData: false,
  registrationConfig: {
    apiEndpoint: process.env.REACT_APP_EXTENSION_API_ENDPOINT,
    resource: process.env.REACT_APP_EXTENSION_API_RESOURCE,
    active: true,
  },
  botConfig: {
    hostAppId: process.env.REACT_APP_BOT_HOST_APP_ID,
    scriptUrl: process.env.REACT_APP_BOT_SCRIPT_URL,
    active: false,
  },
  globalSearchConfig: {
    active: false,
  },
  guidedTourConfig: {
    active: false,
  },
  ocvFeedbackConfig: {
    appId: parseInt(process.env.REACT_APP_OCV_APP_ID),
    sdkUrl: process.env.REACT_APP_OCV_SDK_URL,
    active: false,
  },
  notificaitonConfig: {
    active: false,
    customPanel: false,
  },
  themeConfig: {
    theme: 'default',
    active: true,
  },
  loginOnStartup: false,
  enableUserSettingsApi: false,
  brandConfig: {
    active: false,
    loginScreenOnly: false,
  },
  languageConfig: {
    active: false,
    locales: {
      "en": "English - EN ",
      "es": "Español - es",
      "pt": "Português - pt",
    },
  },
}